<template>
  <div class="app-container">
    <div>
      <!-- 查询区域 -->
      <el-card class="filter-container" shadow="never">
        <div class="search">
          <i class="el-icon-search"></i>
          <span>筛选搜索</span>
          <div style="margin-top: 15px">
            <el-form :inline="true" size="small" label-width="100px">
              <el-form-item label="标题：">
                <el-input v-model="listNews.newsTitle" style="width: 140px" placeholder="标题模糊查询"></el-input>
              </el-form-item>
              <el-form-item style="float: right">
                <el-button
                  icon="el-icon-search"
                  @click="handleSearch()"
                  type="primary"
                  size="small"
                >查询</el-button>
                <el-button icon="el-icon-refresh" @click="handleResetSearch()" size="small">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-card>

      <!-- 操作区域 -->
      <el-card class="operate-container" shadow="never">
        <div class="search">
          <i class="el-icon-tickets"></i>
          <span>数据列表</span>
          <el-form
            style="padding-left: 45px"
            :inline="true"
            :model="listNews"
            size="small"
            label-width="100px"
          >
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" @click="handleAddBtn()" type="primary" size="mini">新增</el-button>
            </el-form-item>
          </el-form>
          <div style="clear: both"></div>
        </div>
      </el-card>

      <!-- 数据表格 -->
      <div style="margin: 20px">
        <el-table
          ref="multipleTable"
          v-loading="loading"
          element-loading-text="拼命加载中"
          size="mini"
          :data="tableData"
          border
          highlight-current-row
          style="width: 100%;"
          @sort-change="handleSortChange"
        >
          <el-table-column label="序号" width="100" align="center">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="标题" min-width="150" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.newsTitle }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="140" align="center">
            <template slot-scope="scope">
              <span>{{ formatDate(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" min-width="140" align="center">
            <template slot-scope="scope">
              <span>{{ formatDate(scope.row.releaseTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建人" min-width="140" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.createBy }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="180" label="操作" class-name="status-col" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleUpdateBtn(scope.row)"
                icon="el-icon-edit"
              >修改</el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleDelBtn(scope.row)"
                icon="el-icon-delete"
                class="icon-color"
              >删除</el-button>
              <el-button
                size="mini"
                type="text"
                @click="handledetailBtn(scope.row)"
                icon="el-icon-view"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--分页-->
        <div class="pagination-container">
          <el-pagination
            v-show="this.tableData.length > 0"
            :current-page.sync="listNews.pageNum"
            :page-sizes="[10,20,50,100]"
            :page-size="listNews.pageSize"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
        <el-drawer
          :title="title"
          :size="'80%'" 
          :visible.sync="question_dialogVisible"
          :close-on-click-modal="false"
          :destroy-on-close="true"
          @close="closeDialog"
        >
          <newsTypes
            v-if="question_dialogVisible"
            :params="questionsModel"
            @close="closeDialog"
            @handleSaveNews="handleSaveNewsFromDialog"
          ></newsTypes>
        </el-drawer>

        <el-drawer
          :title="title"
          :size="'80%'" 
          :visible.sync="detailDialogVisible"
          :close-on-click-modal="false"
          :destroy-on-close="true"
          @close="handleDetailDialogClose"
        >
          <el-scrollbar class="test">
            <newsDetail
              v-if="detailDialogVisible"
              :params="detailQuestionsModel"
              @close="handleDetailDialogClose"
            ></newsDetail>
          </el-scrollbar>
        </el-drawer>
      </div>
    </div>
  </div>
</template>
 
<script>
  import {
    formatDate,
    addDateRange
  } from "@/utils/date";
import {
  addNews,
  getAllNews,
  deleteNews,
  updateNews
} from "@/api/news/newsInfo.js";
import newsTypes from "@/components/Common/newsTypes.vue";
import newsDetail from "@/components/Common/newsDetail.vue";
export default {
  components: {
    newsTypes,
    newsDetail
  },
  data() {
    return {
      loading: false,
      listNews: {
        newsContent:"",
        newsTitle: "",
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0,
      title: "",
      isUpdate: false,
      detailDialogVisible: false,
      question_dialogVisible: false,
      questionsModel: {},
      detailQuestionsModel: {}
    };
  },
  methods: {
    fetchNews() {
      getAllNews(this.listNews).then(res => {
        console.log(res);
        this.tableData = res.data.records;
        this.total = res.data.total;
      //   this.tableData.forEach(newsContent => {

      //     row.newsContent = this.addPrefixToImg(
      //         row.newsContent,
      //           base_url_src
      //         );
      // });
    },
  )},
    handleSearch() {
      this.fetchNews();
    },
    handleAddBtn() {
      this.questionsModel = {};
      this.title = "新增新闻";
      this.isUpdate = false;
      this.question_dialogVisible = true;
    },
    handleCancelBtn() {
      this.question_dialogVisible = false;
      this.questionsModel = {};
    },
    handleResetSearch() {
      this.listNews.newsTitle = "";
      this.listNews.pageNum = 1;
      this.handleSearch();
    },
    sortCreateTime(a, b) {
      return new Date(a.createTime) - new Date(b.createTime);
    },
    // 在表格组件上监听 sort-change 事件
    handleSortChange({ column, prop, order }) {
      if (prop === "createTime") {
        this.tableData.sort(this.sortCreateTime);
        if (order === "descending") {
          this.tableData.reverse();
        }
      }
    },
    handleDelBtn(row) {
      this.$confirm("此操作将永久删除该新闻, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteNews(row.id)
            .then(res => {
              if ((res.data && res.data.success) || res.status === 0) {
                this.init();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message.error(
                  "删除失败: " + (res.data.message || "未知错误")
                );
              }
            })
            .catch(error => {
              console.error("删除请求失败:", error);
              this.$message.error("删除请求失败，请稍后再试");
            });
        })
        .catch(() => {});
    },
    init() {
      this.fetchNews();
      // this.getList();
    },
    handledetailBtn(row) {
      this.title = "详情信息";
      console.log(1155)
      console.log(row)
      row.newsContent = this.addPrefixToImg(
        row.newsContent,
                base_url_src
              );

              console.log(row)
              console.log(base_url_src)
      this.detailQuestionsModel = row ;
      this.detailDialogVisible = true;
    },
    handleDetailDialogClose() {
      this.detailDialogVisible = false;
      this.detailQuestionsModel = {};
    },
    handleSizeChange(size) {
      this.listNews.pageSize = size;
      this.handleSearch();
    },
    handleCurrentChange(page) {
      this.listNews.pageNum = page;
      this.handleSearch();
    },
    closeDialog() {
      this.question_dialogVisible = false;
      this.questionsModel = {};
    },
    handleSaveNewsFromDialog(news) {
      console.log(news);
      if (this.isUpdate) {
        updateNews({ ...news, id: this.questionsModel.id })
          .then(res => {
            if (res.status === 0) {
              this.$message({
                type: "success",
                message: "修改成功!"
              });
              this.closeDialog();
              this.fetchNews();
            } else {
              this.$message.error("修改失败!");
            }
          })
          .catch(error => {
            console.error("更新请求失败:", error);
            this.$message.error("更新请求失败，请稍后再试");
          });
      } else {
        // 如果是新增操作
        addNews(news)
          .then(res => {
            if (res.status === 0) {
              this.$message({
                type: "success",
                message: "新增成功!"
              });
              this.closeDialog();
              this.fetchNews();
            } else {
              this.$message.error("新增失败!");
            }
          })
          .catch(error => {
            console.error("新增请求失败:", error);
            this.$message.error("新增请求失败，请稍后再试");
          });
      }
    },
    formatDate(time) {
        let date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },

    handleUpdateBtn(row) {
      this.title = "修改新闻信息";
      this.isUpdate = true;
      row.newsContent = this.addPrefixToImg(
        row.newsContent,
                base_url_src
              );

              console.log(row)
              console.log(base_url_src)
      this.questionsModel = Object.assign({}, row);
      if (row.analysis && row.analysis.length > 0) {
        this.questionsModel.analysisChecked = true;
      }
      this.question_dialogVisible = true;
    },
    addPrefixToImg(html, prefix) {
        if (html == null)
          return
        const regexp = /<img[^>]+src="([^">]+)"/g;
        const modifiedHtml = html.replace(regexp, (match, src) => {
          if (!src.startsWith(prefix)) {
            return match.replace(src, `${prefix}${src}`);
          }

          return match;
        });
        return modifiedHtml;
      },
      getList() {
        this.loading = true;
        getAllNews(addDateRange(this.listNews)).then(
          response => {
           
            this.tableData = response.data.list;

            this.tableData.sort(
              (a, b) => new Date(a.createTime) - new Date(b.createTime)
            );
            this.loading = false;
            this.total = response.data.total;
          }
        );
      },

  },

  created() {
    this.fetchNews();
  }
};
</script>
<style scoped>


.test {
height: 100%;
}

>>>.el-scrollbar__wrap {
  overflow-x: hidden;
}
.search {
  text-align: left;
}

.app-container {
  padding: 20px;
}

.filter-container {
  margin-bottom: 20px;
}

.operate-container {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: right;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/mangement.vue